module.exports = __webpack_public_path__ + "static/media/shuzhihua1.eb131801.png";